import React from 'react';

export const DropdownDivider = () => {
  return (
    <div className="my-1">
      <div className="border-b border-gray-100" />
    </div>
  );
};
